import React from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { IFormElement } from "../../atlas-form-core/Interfaces";
import "./form.date.time.range.picker.scss";

const { RangePicker } = DatePicker;

interface IProps {
  className?: string;
  onChange?: (dates?: (string | null)[]) => void;
  value?: (string | null)[];
  format?: string;
  style?: IFormElement["element_style"];
  disabled?: boolean;
  placeholder?: [string, string];
}

function FormDateTimeRangePicker(props: IProps) {
  const handleChange = (dates, dateStrings) => {
    if (props.onChange) {
      if (!dates || dates.length === 0) {
        // If no dates selected, return undefined
        props.onChange(undefined);
      } else {
        // Just pass through the dates as they are - user can modify times as needed
        const formattedDates = dates.map((date) => (date ? date.format() : null));
        props.onChange(formattedDates);
      }
    }
  };

  const getMomentValues = () => {
    if (!props.value || !Array.isArray(props.value)) {
      return undefined;
    }

    // Allow partial values - convert each value to moment or null
    const momentValues = props.value.map((dateStr) => {
      if (!dateStr) return null;
      const momentDate = moment(dateStr);
      return momentDate.isValid() ? momentDate : null;
    });

    return momentValues as [moment.Moment | null, moment.Moment | null];
  };

  return (
    <RangePicker
      className={props.className}
      showTime={{
        defaultValue: [
          moment("00:00:00", "HH:mm:ss"), // Default time for "from" date
          moment("23:59:59", "HH:mm:ss"), // Default time for "to" date
        ],
      }}
      allowEmpty={[true, true]}
      format={props.format || "YYYY-MM-DD HH:mm"}
      value={getMomentValues()}
      onChange={handleChange}
      style={{ ...props.style }}
      disabled={props.disabled}
      placeholder={props.placeholder || ["From date & time", "To date & time"]}
    />
  );
}

export default React.memo(FormDateTimeRangePicker);
